import { ContractStatusEnum } from '@monetize/types/app';
import { MdInfo } from 'react-icons/md';
import {
  CONTRACT_PENDING_STATUS_TOOLTIP,
  CONTRACT_STATUS_DISPLAY,
  CONTRACT_STATUS_TAG_VARIANT,
} from '../../../constants/contracts';
import { MIcon, MTag, MTooltip } from '../../Monetize';

export const ContractStatusTag = ({
  status,
  hasTooltip = true,
}: {
  status: ContractStatusEnum;
  /** Turn off inside other interactive elements, where a focusable tooltip would nest */
  hasTooltip?: boolean;
}) => {
  const tag = (
    <MTag variant={CONTRACT_STATUS_TAG_VARIANT[status]} flexShrink={0}>
      {CONTRACT_STATUS_DISPLAY[status]}
      {status === ContractStatusEnum.PENDING && hasTooltip && (
        <MIcon as={MdInfo} ml={1} color="fg.muted" />
      )}
    </MTag>
  );

  if (status !== ContractStatusEnum.PENDING || !hasTooltip) {
    return tag;
  }
  return (
    <MTooltip label={CONTRACT_PENDING_STATUS_TOOLTIP} shouldWrapChildren>
      {tag}
    </MTooltip>
  );
};
